import React from 'react';
import '../styling/PP.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1 className="privacy-title">Privacy Policy</h1>


      <section className="policy-section">
        <h2>Information Collection</h2>
        <p>
          We collect information from you when you register on our site, place an order, subscribe to our newsletter, or fill out a form. When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address, mailing address, phone number, or credit card information.
        </p>
        <p>
          You may, however, visit our site anonymously. We will not sell, trade, or otherwise transfer to outside parties your personally identifiable information without your consent, except as necessary to fulfill your requests, or comply with the law.
        </p>
      </section>

      <section className="policy-section">
        <h2>Information Use</h2>
        <p>
          The information we collect from you may be used to personalize your experience, improve our website, improve customer service, process transactions, administer a contest, promotion, survey, or other site features, or send periodic emails.
        </p>
        <p>
          Your information helps us to better respond to your individual needs and efficiently handle your transactions. We implement a variety of security measures to maintain the safety of your personal information.
        </p>
      </section>

      <section className="policy-section">
        <h2>Information Protection</h2>
        <p>
          We implement a variety of security measures to maintain the safety of your personal information. Your personal information is contained behind secure networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. We use secure socket layer (SSL) technology to encrypt sensitive information you provide during transactions.
        </p>
        <p>
          Despite our efforts to protect your personal information, no transmission over the Internet or electronic storage method is 100% secure. Therefore, we cannot guarantee absolute security. However, we strive to use commercially acceptable means to protect your personal information.
        </p>
      </section>

      <section className="policy-section">
        <h2>Cookies</h2>
        <p>
          We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. Cookies are small data files stored on your device that help us remember your preferences and understand how you use our site.
        </p>
        <p>
          You can choose to disable cookies through your browser settings. However, doing so may limit your ability to use certain features on our website.
        </p>
      </section>

      <section className="policy-section">
        <h2>Third-Party Links</h2>
        <p>
          Our website may contain links to third-party sites. These sites have separate and independent privacy policies. We have no control over and are not responsible for the content and activities of these linked sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites.
        </p>
      </section>

      <section className="policy-section">
        <h2>Changes to Our Privacy Policy</h2>
        <p>
          We may update our privacy policy from time to time to reflect changes in our practices or legal requirements. Any updates will be posted on this page, and the revised date will be indicated at the top of the policy.
        </p>
        <p>
          We encourage you to review our privacy policy periodically to stay informed about how we are protecting your information.
        </p>
      </section>

      <section className="policy-section">
        <h2>Contact Us</h2>
        <p>
          If you have any questions or concerns about our privacy policy or how we handle your personal information, please contact us at:
        </p>
        <p>
          <strong>Email:</strong> truehood.business@gmail.com <br />
          <strong>WhatsApp:</strong> +91 9618825172
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicy;